import TIM from 'tim-js-sdk'
import $store from '../../store/index'
import { logPost } from '../api/index'

let customerTim = null
let messageHandler = null
let hasBoundEvents = false

const safeParsePayload = (message) => {
  try {
    const text = message && message.payload ? message.payload.text : ''
    if (!text) return null
    return JSON.parse(text)
  } catch (e) {
    return null
  }
}

const bindEvents = (userID) => {
  if (!customerTim || hasBoundEvents) return
  hasBoundEvents = true

  customerTim.on(TIM.EVENT.MESSAGE_RECEIVED, (event) => {
    const messageList = (event && event.data) || []
    messageList.forEach((message) => {
      $store.commit('set_customerImLastRawMessage', message)
      const parsed = safeParsePayload(message)
      if (parsed) {
        $store.commit('set_customerImLastParsedMessage', parsed)
      }
      if (typeof messageHandler === 'function') {
        messageHandler(message)
      }
    })
  })

  customerTim.on(TIM.EVENT.KICKED_OUT, (event) => {
    logPost({ a: 74102, c: '客服IM收到被踢下线通知', r: '/', e: event, uid: userID, ua: navigator.userAgent })
    destroyCustomerIM()
  })

  customerTim.on(TIM.EVENT.ERROR, (event) => {
    logPost({ a: 74103, c: '客服IM收到 SDK 的错误通知', r: '/', e: event, uid: userID, ua: navigator.userAgent })
  })

  customerTim.on(TIM.EVENT.NET_STATE_CHANGE, (event) => {
    const state = event && event.data && event.data.state ? event.data.state : ''
    $store.commit('set_customerImConnectionState', state)
    logPost({ a: 74105, c: '客服IM网络状态发生改变', r: '/', e: event, uid: userID, ua: navigator.userAgent })
  })

  customerTim.on(TIM.EVENT.SDK_NOT_READY, (event) => {
    $store.commit('set_customerImReady', false)
    logPost({ a: 74104, c: '客服IM进入 not ready 状态', r: '/', e: event, uid: userID, ua: navigator.userAgent })
  })

  customerTim.on(TIM.EVENT.SDK_READY, () => {
    $store.commit('set_customerImReady', true)
    $store.commit('set_customerTim', customerTim)
  })
}

export const initCustomerIM = ({ SDKAppID, userID, userSig, onMessage }) => {
  if (!SDKAppID || !userID || !userSig) return Promise.reject(new Error('missing customer im params'))

  if (!customerTim) {
    customerTim = TIM.create({ SDKAppID })
    customerTim.setLogLevel(1)
    $store.commit('set_customerTim', customerTim)
  }

  if (typeof onMessage === 'function') {
    messageHandler = onMessage
  }

  bindEvents(userID)

  return customerTim.login({ userID, userSig }).then((res) => {
    $store.commit('set_customerImLogin', true)
    return res
  }).catch((err) => {
    $store.commit('set_customerImLogin', false)
    logPost({ a: 74101, c: '客服IM登录失败', r: '/', e: err, uid: userID, ua: navigator.userAgent })
    throw err
  })
}

export const setCustomerIMMessageHandler = (handler) => {
  messageHandler = typeof handler === 'function' ? handler : null
}

export const getCustomerIMInstance = () => customerTim

export const destroyCustomerIM = async () => {
  const target = customerTim
  messageHandler = null
  hasBoundEvents = false
  customerTim = null
  $store.commit('reset_customerImState')
  if (!target) return
  try {
    await target.logout()
  } catch (e) {
  } finally {
    if (typeof target.destroy === 'function') {
      target.destroy()
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/customerImClient.js